var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "app-container-sitc" },
    [
      _c("div", { staticClass: "filter-container-content" }, [
        _c(
          "div",
          { staticStyle: { padding: "0 40px" } },
          [
            _c("span", { staticClass: "title-h4" }, [
              _vm._v(_vm._s(_vm.$t("vgmApply.title"))),
            ]),
            _vm._v(" "),
            _c(
              "el-form",
              {
                ref: "form",
                staticClass: "search-form",
                attrs: {
                  model: _vm.form,
                  "label-position": "top",
                  rules: _vm.formRules,
                },
              },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 14 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            staticClass: "xRequired",
                            attrs: {
                              label: _vm.$t("vgmApply.containerNo"),
                              prop: "containerNo",
                              "label-width": "110px",
                            },
                          },
                          [
                            _c("el-input", {
                              attrs: {
                                onkeyup:
                                  "this.value = this.value.toUpperCase()",
                                placeholder: _vm.$t("placeholder.containerNo"),
                                clearable: "",
                              },
                              model: {
                                value: _vm.form.containerNo,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "containerNo", $$v)
                                },
                                expression: "form.containerNo",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      {
                        staticStyle: { "margin-top": "28px" },
                        attrs: { span: 6 },
                      },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 9 } },
                          [
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-select",
                                  {
                                    staticClass: "Required",
                                    attrs: { "label-width": "110px" },
                                    on: { change: _vm.onChange },
                                    model: {
                                      value: _vm.selectValue,
                                      callback: function ($$v) {
                                        _vm.selectValue = $$v
                                      },
                                      expression: "selectValue",
                                    },
                                  },
                                  _vm._l(_vm.selectOptions, function (item) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        label: item.label,
                                        value: item.value,
                                      },
                                    })
                                  }),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 15 } },
                          [
                            this.selectValue === 0
                              ? _c(
                                  "el-form-item",
                                  { attrs: { prop: "bkNo" } },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        onkeyup:
                                          "this.value = this.value.toUpperCase()",
                                        placeholder: _vm.$t("placeholder.bkNo"),
                                        clearable: "",
                                      },
                                      model: {
                                        value: _vm.form.bkNo,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form, "bkNo", $$v)
                                        },
                                        expression: "form.bkNo",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : this.selectValue === 1
                              ? _c(
                                  "el-form-item",
                                  { attrs: { prop: "blNo" } },
                                  [
                                    _c("el-input", {
                                      attrs: {
                                        onkeyup:
                                          "this.value = this.value.toUpperCase()",
                                        placeholder: _vm.$t("placeholder.blNo"),
                                        clearable: "",
                                      },
                                      model: {
                                        value: _vm.form.blNo,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form, "blNo", $$v)
                                        },
                                        expression: "form.blNo",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : this.selectValue === 2
                              ? _c(
                                  "el-form-item",
                                  { attrs: { prop: "vesselCode" } },
                                  [
                                    _c("el-input", {
                                      staticStyle: { width: "41%" },
                                      attrs: {
                                        onkeyup:
                                          "this.value = this.value.toUpperCase()",
                                      },
                                      model: {
                                        value: _vm.form.vesselCode,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form, "vesselCode", $$v)
                                        },
                                        expression: "form.vesselCode",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("el-input", {
                                      staticStyle: { width: "32%" },
                                      attrs: {
                                        onkeyup:
                                          "this.value = this.value.toUpperCase()",
                                      },
                                      model: {
                                        value: _vm.form.voyageNo,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form, "voyageNo", $$v)
                                        },
                                        expression: "form.voyageNo",
                                      },
                                    }),
                                    _vm._v(" "),
                                    _c("el-input", {
                                      staticStyle: { width: "20%" },
                                      attrs: {
                                        onkeyup:
                                          "this.value = this.value.toUpperCase()",
                                      },
                                      model: {
                                        value: _vm.form.voyageLeg,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.form, "voyageLeg", $$v)
                                        },
                                        expression: "form.voyageLeg",
                                      },
                                    }),
                                  ],
                                  1
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      { attrs: { span: 6 } },
                      [
                        _c(
                          "el-form-item",
                          {
                            attrs: {
                              label: _vm.$t("vgmApply.importFlag"),
                              prop: "importFlag",
                              "label-width": "110px",
                            },
                          },
                          [
                            _c(
                              "el-select",
                              {
                                staticStyle: { width: "100%" },
                                attrs: { clearable: "" },
                                model: {
                                  value: _vm.form.importFlag,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.form, "importFlag", $$v)
                                  },
                                  expression: "form.importFlag",
                                },
                              },
                              _vm._l(_vm.importStatusOptions, function (item) {
                                return _c("el-option", {
                                  key: item.value,
                                  attrs: {
                                    label: item.label,
                                    value: item.value,
                                  },
                                })
                              }),
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-col",
                      {
                        staticStyle: {
                          "text-align": "left",
                          "margin-top": "28px",
                        },
                        attrs: { span: 5, offset: 1 },
                      },
                      [
                        _c(
                          "el-button",
                          {
                            staticClass: "btn-primary",
                            attrs: { type: "primary" },
                            on: { click: _vm.toSearch },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("button.search")) +
                                "\n            "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticClass: "btn-plain-primary",
                            attrs: { type: "primary" },
                            on: { click: _vm.toReset },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("button.reset")) +
                                "\n            "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticStyle: { "margin-top": "10px" } },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "btn-primary",
                        attrs: { type: "success" },
                        on: { click: _vm.addVgmInfo },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("button.new")) +
                            "\n          "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticClass: "btn-plain-primary",
                        attrs: { type: "warning" },
                        on: { click: _vm.downloadTemplate },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("button.excelTemplate")) +
                            "\n          "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticClass: "btn-plain-primary",
                        attrs: { type: "warning" },
                      },
                      [
                        _c(
                          "el-upload",
                          {
                            staticClass: "upload-file",
                            attrs: {
                              headers: _vm.headers,
                              action: _vm.uploadExcel,
                              "on-error": _vm.handelOnError,
                              "on-success": _vm.handleSuccess,
                              "before-upload": _vm.handleBeforeUpload,
                              limit: 1,
                              data: _vm.excelParam,
                              accept: ".xlsx,.xls",
                              "show-file-list": false,
                              "file-list": _vm.fileList,
                            },
                          },
                          [
                            _vm._v(
                              "\n              " +
                                _vm._s(_vm.$t("button.importExcel")) +
                                "\n            "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _vm.isResult
        ? _c(
            "div",
            { staticClass: "result-container" },
            [
              _c("h4", [_vm._v("VGM Information")]),
              _vm._v(" "),
              _c(
                "el-table",
                {
                  staticStyle: { width: "100%" },
                  attrs: {
                    data: _vm.baseInfo,
                    border: "",
                    "highlight-current-row": "",
                  },
                },
                [
                  _c("el-table-column", {
                    attrs: {
                      type: "index",
                      label: "NO.",
                      width: "40",
                      fixed: "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "bkNo",
                      label: _vm.$t("vgmApply.bkNo"),
                      "min-width": "25%",
                      fixed: "",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "blNo",
                      label: _vm.$t("vgmApply.blNo"),
                      "min-width": "25%",
                      "show-overflow-tooltip": "",
                      fixed: "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "containerNo",
                      label: _vm.$t("vgmApply.containerNo"),
                      "min-width": "22%",
                      "show-overflow-tooltip": "",
                      fixed: "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "vesselCode",
                      label: _vm.$t("vgmApply.vesselCode"),
                      "min-width": "16%",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "voyageNo",
                      label: _vm.$t("vgmApply.voyageNo"),
                      "min-width": "15%",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "vgmGrossWeight",
                      label: _vm.$t("vgmApply.vgmGrossWeight"),
                      "min-width": "16%",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "vgmScale",
                      label: _vm.$t("vgmApply.vgmScale"),
                      "min-width": "16",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                _vm._s(_vm.scaleTypeName[scope.row.vgmScale])
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      4077554520
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "vgmMethod",
                      label: _vm.$t("vgmApply.vgmMethod"),
                      "min-width": "16%",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                _vm._s(_vm.methodTypeName[scope.row.vgmMethod])
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      401847896
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "vgmDate",
                      label: _vm.$t("vgmApply.vgmDate"),
                      "min-width": "24%",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "location",
                      label: _vm.$t("vgmApply.location"),
                      "min-width": "16%",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "importFlag",
                      label: _vm.$t("vgmApply.importFlag"),
                      "min-width": "20%",
                      "show-overflow-tooltip": "",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _vm._v(
                                _vm._s(_vm.importFlagName[scope.row.importFlag])
                              ),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      2714326812
                    ),
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      prop: "rejectReason",
                      label: _vm.$t("vgmApply.rejectReason"),
                      "min-width": "20%",
                      "show-overflow-tooltip": "",
                    },
                  }),
                  _vm._v(" "),
                  _c("el-table-column", {
                    attrs: {
                      fixed: "right",
                      label: _vm.$t("vgmApply.operate"),
                      width: "135",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "text", size: "small" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleCopy(scope.row)
                                    },
                                  },
                                },
                                [_vm._v(" " + _vm._s(_vm.$t("button.copy")))]
                              ),
                              _vm._v(" "),
                              scope.row.importFlag != 2 &&
                              scope.row.exportFlag != 1
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text", size: "small" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleEdit(scope.row)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(_vm.$t("button.edit")) +
                                          "\n          "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              scope.row.importFlag == 1 ||
                              scope.row.importFlag == 3 ||
                              scope.row.importFlagCnshk == 3
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { type: "text", size: "small" },
                                      on: {
                                        click: function ($event) {
                                          return _vm.handleDelete(scope.row)
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        "\n            " +
                                          _vm._s(_vm.$t("button.delete")) +
                                          "\n          "
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ]
                          },
                        },
                      ],
                      null,
                      false,
                      1672481855
                    ),
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "block",
                  staticStyle: { "text-align": "center", margin: "10px" },
                },
                [
                  _c("el-pagination", {
                    attrs: {
                      "current-page": _vm.page.pageIndex,
                      "page-sizes": [10, 20, 50, 100],
                      "page-size": _vm.page.pageSize,
                      layout: "total,sizes, prev, pager, next",
                      total: _vm.page.total,
                    },
                    on: {
                      "size-change": _vm.handleSizeChange,
                      "current-change": _vm.handleCurChange,
                      "update:currentPage": function ($event) {
                        return _vm.$set(_vm.page, "pageIndex", $event)
                      },
                      "update:current-page": function ($event) {
                        return _vm.$set(_vm.page, "pageIndex", $event)
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.vgmDeclareVisible, center: "", fullscreen: "" },
          on: {
            "update:visible": function ($event) {
              _vm.vgmDeclareVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "add-container" },
            [
              _c("span", { staticClass: "title-h4" }, [
                _vm._v(_vm._s(_vm.$t("vgmApplyInfo.title"))),
              ]),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  ref: "bkVgmWeb",
                  staticClass: "search-form",
                  attrs: {
                    model: _vm.bkVgmWeb,
                    rules: _vm.bkVgmWebRules,
                    "label-width": "115px",
                  },
                },
                [
                  _c(
                    "el-collapse",
                    {
                      staticStyle: { "margin-bottom": "30px" },
                      model: {
                        value: _vm.activeNames,
                        callback: function ($$v) {
                          _vm.activeNames = $$v
                        },
                        expression: "activeNames",
                      },
                    },
                    [
                      _c(
                        "el-collapse-item",
                        { attrs: { title: "VGM Container", name: "1" } },
                        [
                          _c(
                            "el-row",
                            { attrs: { gutter: 14 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t("vgmApplyInfo.bkNo"),
                                        prop: "bkNo",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          onkeyup:
                                            "this.value = this.value.toUpperCase()",
                                          placeholder:
                                            _vm.$t("placeholder.bkNo"),
                                          clearable: "",
                                        },
                                        on: { blur: _vm.bkToVVL },
                                        model: {
                                          value: _vm.bkVgmWeb.bkNo,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.bkVgmWeb,
                                              "bkNo",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression: "bkVgmWeb.bkNo",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("el-input", {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value: false,
                                            expression: "false",
                                          },
                                        ],
                                        model: {
                                          value: _vm.bkVgmWeb.bkVgmContainerId,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.bkVgmWeb,
                                              "bkVgmContainerId",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "bkVgmWeb.bkVgmContainerId",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t("vgmApplyInfo.blNo"),
                                        prop: "blNo",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          onkeyup:
                                            "this.value = this.value.toUpperCase()",
                                          placeholder:
                                            _vm.$t("placeholder.blNo"),
                                          clearable: "",
                                        },
                                        on: { blur: _vm.blToVVL },
                                        model: {
                                          value: _vm.bkVgmWeb.blNo,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.bkVgmWeb,
                                              "blNo",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression: "bkVgmWeb.blNo",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "is-required xRequired",
                                      attrs: {
                                        label: _vm.$t("vgmApplyInfo.vvl"),
                                        prop: "vesselCode",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        staticStyle: { width: "33%" },
                                        attrs: {
                                          onkeyup:
                                            "this.value = this.value.toUpperCase()",
                                        },
                                        model: {
                                          value: _vm.bkVgmWeb.vesselCode,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.bkVgmWeb,
                                              "vesselCode",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression: "bkVgmWeb.vesselCode",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("el-input", {
                                        staticStyle: { width: "29%" },
                                        attrs: {
                                          onkeyup:
                                            "this.value = this.value.toUpperCase()",
                                        },
                                        model: {
                                          value: _vm.bkVgmWeb.voyageNo,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.bkVgmWeb,
                                              "voyageNo",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression: "bkVgmWeb.voyageNo",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c("el-input", {
                                        staticStyle: { width: "17%" },
                                        attrs: {
                                          onkeyup:
                                            "this.value = this.value.toUpperCase()",
                                        },
                                        model: {
                                          value: _vm.bkVgmWeb.voyageLeg,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.bkVgmWeb,
                                              "voyageLeg",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression: "bkVgmWeb.voyageLeg",
                                        },
                                      }),
                                      _vm._v(" "),
                                      _c(
                                        "el-popover",
                                        {
                                          attrs: {
                                            placement: "right-start",
                                            width: "720",
                                            trigger: "manual",
                                          },
                                          model: {
                                            value: _vm.vvlVisible,
                                            callback: function ($$v) {
                                              _vm.vvlVisible = $$v
                                            },
                                            expression: "vvlVisible",
                                          },
                                        },
                                        [
                                          _c("div", [
                                            _c(
                                              "div",
                                              {
                                                staticStyle: {
                                                  padding: "0px 5px",
                                                  margin: "-14px",
                                                },
                                              },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      "text-align": "right",
                                                      "font-size": "24px",
                                                    },
                                                  },
                                                  [
                                                    _c("i", {
                                                      staticClass:
                                                        "el-icon-circle-close",
                                                      on: {
                                                        click: _vm.onClose,
                                                      },
                                                    }),
                                                  ]
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      "background-color":
                                                        "#dfeefe",
                                                      "margin-top": "-30px",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "el-divider",
                                                      {
                                                        attrs: {
                                                          "content-position":
                                                            "left",
                                                        },
                                                      },
                                                      [_vm._v("Choose VVL")]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "el-form",
                                                      {
                                                        staticStyle: {
                                                          "background-color":
                                                            "#dfeefe",
                                                        },
                                                        attrs: {
                                                          inline: true,
                                                          model: _vm.vvlFrom,
                                                          "label-width": "85px",
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "el-row",
                                                          [
                                                            _c(
                                                              "el-col",
                                                              {
                                                                attrs: {
                                                                  span: 11,
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "el-form-item",
                                                                  {
                                                                    attrs: {
                                                                      label:
                                                                        _vm.$t(
                                                                          "vgmApplyInfo.vesselCode"
                                                                        ),
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "glVesselMain",
                                                                      {
                                                                        attrs: {
                                                                          displayCode: true,
                                                                          "label-prop":
                                                                            _vm
                                                                              .vvlFrom
                                                                              .vesselCode,
                                                                        },
                                                                        on: {
                                                                          change:
                                                                            _vm.vesselCodeChange,
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .vvlFrom
                                                                              .vesselCode,
                                                                          callback:
                                                                            function (
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                _vm.vvlFrom,
                                                                                "vesselCode",
                                                                                $$v
                                                                              )
                                                                            },
                                                                          expression:
                                                                            "vvlFrom.vesselCode",
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "el-col",
                                                              {
                                                                attrs: {
                                                                  span: 11,
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "el-form-item",
                                                                  {
                                                                    attrs: {
                                                                      label:
                                                                        _vm.$t(
                                                                          "vgmApplyInfo.vesselName"
                                                                        ),
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "el-input",
                                                                      {
                                                                        attrs: {
                                                                          placeholder:
                                                                            _vm.$t(
                                                                              "vgmApplyInfo.vesselName"
                                                                            ),
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .vvlFrom
                                                                              .vesselName,
                                                                          callback:
                                                                            function (
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                _vm.vvlFrom,
                                                                                "vesselName",
                                                                                $$v
                                                                              )
                                                                            },
                                                                          expression:
                                                                            "vvlFrom.vesselName",
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "el-row",
                                                          [
                                                            _c(
                                                              "el-col",
                                                              {
                                                                attrs: {
                                                                  span: 11,
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "el-form-item",
                                                                  {
                                                                    attrs: {
                                                                      label:
                                                                        _vm.$t(
                                                                          "vgmApplyInfo.voyageNo"
                                                                        ),
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "el-input",
                                                                      {
                                                                        attrs: {
                                                                          placeholder:
                                                                            _vm.$t(
                                                                              "placeholder.voyageNo"
                                                                            ),
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .vvlFrom
                                                                              .voyageNo,
                                                                          callback:
                                                                            function (
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                _vm.vvlFrom,
                                                                                "voyageNo",
                                                                                $$v
                                                                              )
                                                                            },
                                                                          expression:
                                                                            "vvlFrom.voyageNo",
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                            _vm._v(" "),
                                                            _c(
                                                              "el-col",
                                                              {
                                                                attrs: {
                                                                  span: 11,
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "el-form-item",
                                                                  {
                                                                    attrs: {
                                                                      label:
                                                                        _vm.$t(
                                                                          "vgmApplyInfo.voyageLeg"
                                                                        ),
                                                                    },
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "el-input",
                                                                      {
                                                                        attrs: {
                                                                          placeholder:
                                                                            _vm.$t(
                                                                              "placeholder.voyageLeg"
                                                                            ),
                                                                        },
                                                                        model: {
                                                                          value:
                                                                            _vm
                                                                              .vvlFrom
                                                                              .voyageLeg,
                                                                          callback:
                                                                            function (
                                                                              $$v
                                                                            ) {
                                                                              _vm.$set(
                                                                                _vm.vvlFrom,
                                                                                "voyageLeg",
                                                                                $$v
                                                                              )
                                                                            },
                                                                          expression:
                                                                            "vvlFrom.voyageLeg",
                                                                        },
                                                                      }
                                                                    ),
                                                                  ],
                                                                  1
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                        _vm._v(" "),
                                                        _c(
                                                          "el-row",
                                                          [
                                                            _c(
                                                              "el-col",
                                                              {
                                                                attrs: {
                                                                  span: 11,
                                                                  offset: 12,
                                                                },
                                                              },
                                                              [
                                                                _c(
                                                                  "el-button",
                                                                  {
                                                                    staticClass:
                                                                      "btn-primary",
                                                                    attrs: {
                                                                      type: "primary",
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        _vm.searchVVL,
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                                  " +
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "button.search"
                                                                          )
                                                                        ) +
                                                                        "\n                                "
                                                                    ),
                                                                  ]
                                                                ),
                                                                _vm._v(" "),
                                                                _c(
                                                                  "el-button",
                                                                  {
                                                                    staticClass:
                                                                      "btn-plain-primary",
                                                                    on: {
                                                                      click:
                                                                        _vm.resetFn,
                                                                    },
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "\n                                  " +
                                                                        _vm._s(
                                                                          _vm.$t(
                                                                            "button.reset"
                                                                          )
                                                                        ) +
                                                                        "\n                                "
                                                                    ),
                                                                  ]
                                                                ),
                                                              ],
                                                              1
                                                            ),
                                                          ],
                                                          1
                                                        ),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  {
                                                    staticStyle: {
                                                      "margin-top": "5px",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "el-table",
                                                      {
                                                        attrs: {
                                                          data: _vm.vvlData,
                                                          "highlight-current-row":
                                                            "",
                                                          size: "mini",
                                                        },
                                                        on: {
                                                          "row-click":
                                                            _vm.fillVVL,
                                                        },
                                                      },
                                                      [
                                                        _c("el-table-column", {
                                                          attrs: {
                                                            type: "index",
                                                            "min-width": "3%",
                                                          },
                                                        }),
                                                        _vm._v(" "),
                                                        _c("el-table-column", {
                                                          attrs: {
                                                            "min-width": "5%",
                                                            property:
                                                              "vesselCode",
                                                            label: _vm.$t(
                                                              "vgmApplyInfo.vesselCode"
                                                            ),
                                                          },
                                                        }),
                                                        _vm._v(" "),
                                                        _c("el-table-column", {
                                                          attrs: {
                                                            "min-width": "8%",
                                                            property:
                                                              "vesselName",
                                                            label: _vm.$t(
                                                              "vgmApplyInfo.vesselName"
                                                            ),
                                                          },
                                                        }),
                                                        _vm._v(" "),
                                                        _c("el-table-column", {
                                                          attrs: {
                                                            "min-width": "6%",
                                                            property:
                                                              "vesselNameCn",
                                                            label: _vm.$t(
                                                              "vgmApplyInfo.vesselName1"
                                                            ),
                                                          },
                                                        }),
                                                        _vm._v(" "),
                                                        _c("el-table-column", {
                                                          attrs: {
                                                            "min-width": "5%",
                                                            property:
                                                              "voyageNo",
                                                            label: _vm.$t(
                                                              "vgmApplyInfo.voyageNo"
                                                            ),
                                                          },
                                                        }),
                                                        _vm._v(" "),
                                                        _c("el-table-column", {
                                                          attrs: {
                                                            "min-width": "5%",
                                                            property:
                                                              "voyageLeg",
                                                            label: _vm.$t(
                                                              "vgmApplyInfo.voyageLeg"
                                                            ),
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "block",
                                                        staticStyle: {
                                                          "text-align":
                                                            "center",
                                                        },
                                                      },
                                                      [
                                                        _c("el-pagination", {
                                                          attrs: {
                                                            "current-page":
                                                              _vm.vvlPage
                                                                .current,
                                                            "page-size":
                                                              _vm.vvlPage
                                                                .pageSize,
                                                            layout:
                                                              "total,prev,pager, next",
                                                            total:
                                                              _vm.vvlPage.total,
                                                          },
                                                          on: {
                                                            "current-change":
                                                              _vm.handleCurrentChange,
                                                            "update:currentPage":
                                                              function (
                                                                $event
                                                              ) {
                                                                return _vm.$set(
                                                                  _vm.vvlPage,
                                                                  "current",
                                                                  $event
                                                                )
                                                              },
                                                            "update:current-page":
                                                              function (
                                                                $event
                                                              ) {
                                                                return _vm.$set(
                                                                  _vm.vvlPage,
                                                                  "current",
                                                                  $event
                                                                )
                                                              },
                                                          },
                                                        }),
                                                      ],
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ]
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c("el-button", {
                                            staticClass: "btn-primary",
                                            staticStyle: {
                                              width: "14%",
                                              "margin-left": "1%",
                                              "font-size": "16px",
                                            },
                                            attrs: {
                                              slot: "reference",
                                              icon: "el-icon-search",
                                              circle: "",
                                            },
                                            nativeOn: {
                                              click: function ($event) {
                                                return _vm.onShow($event)
                                              },
                                            },
                                            slot: "reference",
                                          }),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t("vgmApplyInfo.remark"),
                                        prop: "remark",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: { clearable: "" },
                                        model: {
                                          value: _vm.bkVgmWeb.remark,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.bkVgmWeb,
                                              "remark",
                                              $$v
                                            )
                                          },
                                          expression: "bkVgmWeb.remark",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-row",
                            { attrs: { gutter: 14 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "xRequired",
                                      attrs: {
                                        label: _vm.$t(
                                          "vgmApplyInfo.containerNo"
                                        ),
                                        prop: "containerNo",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          onkeyup:
                                            "this.value = this.value.toUpperCase()",
                                          placeholder: _vm.$t(
                                            "placeholder.containerNo"
                                          ),
                                          maxlength: 11,
                                          clearable: "",
                                        },
                                        model: {
                                          value: _vm.bkVgmWeb.containerNo,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.bkVgmWeb,
                                              "containerNo",
                                              typeof $$v === "string"
                                                ? $$v.trim()
                                                : $$v
                                            )
                                          },
                                          expression: "bkVgmWeb.containerNo",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "vgmApplyInfo.containerType"
                                        ),
                                        prop: "containerType",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          staticStyle: { width: "100%" },
                                          model: {
                                            value: _vm.bkVgmWeb.containerType,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.bkVgmWeb,
                                                "containerType",
                                                $$v
                                              )
                                            },
                                            expression:
                                              "bkVgmWeb.containerType",
                                          },
                                        },
                                        _vm._l(
                                          _vm.containerTypeOptions,
                                          function (item, index) {
                                            return _c("el-option", {
                                              key: index,
                                              attrs: {
                                                label: item,
                                                value: item,
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "vgmApplyInfo.containerOther"
                                        ),
                                        prop: "containerOther",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: { clearable: "" },
                                        model: {
                                          value: _vm.bkVgmWeb.containerOther,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.bkVgmWeb,
                                              "containerOther",
                                              $$v
                                            )
                                          },
                                          expression: "bkVgmWeb.containerOther",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "xRequired",
                                      attrs: {
                                        label: _vm.$t("vgmApplyInfo.vgmMethod"),
                                        prop: "vgmMethod",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          staticStyle: { width: "100%" },
                                          model: {
                                            value: _vm.bkVgmWeb.vgmMethod,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.bkVgmWeb,
                                                "vgmMethod",
                                                $$v
                                              )
                                            },
                                            expression: "bkVgmWeb.vgmMethod",
                                          },
                                        },
                                        _vm._l(
                                          _vm.methodTypeOptions,
                                          function (item) {
                                            return _c("el-option", {
                                              key: item.value,
                                              attrs: {
                                                label: item.label,
                                                value: item.value,
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-row",
                            { attrs: { gutter: 14 } },
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "xRequired",
                                      attrs: {
                                        label: _vm.$t(
                                          "vgmApplyInfo.vgmGrossWeight"
                                        ),
                                        prop: "vgmGrossWeight",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: { clearable: "" },
                                        model: {
                                          value: _vm.bkVgmWeb.vgmGrossWeight,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.bkVgmWeb,
                                              "vgmGrossWeight",
                                              $$v
                                            )
                                          },
                                          expression: "bkVgmWeb.vgmGrossWeight",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      staticClass: "xRequired",
                                      attrs: {
                                        label: _vm.$t("vgmApplyInfo.vgmScale"),
                                        prop: "vgmScale",
                                      },
                                    },
                                    [
                                      _c(
                                        "el-select",
                                        {
                                          staticStyle: { width: "100%" },
                                          model: {
                                            value: _vm.bkVgmWeb.vgmScale,
                                            callback: function ($$v) {
                                              _vm.$set(
                                                _vm.bkVgmWeb,
                                                "vgmScale",
                                                $$v
                                              )
                                            },
                                            expression: "bkVgmWeb.vgmScale",
                                          },
                                        },
                                        _vm._l(
                                          _vm.scaleTypeOptions,
                                          function (item) {
                                            return _c("el-option", {
                                              key: item.value,
                                              attrs: {
                                                label: item.label,
                                                value: item.value,
                                              },
                                            })
                                          }
                                        ),
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t("vgmApplyInfo.vgmDate"),
                                        prop: "vgmDate",
                                      },
                                    },
                                    [
                                      _c("el-date-picker", {
                                        staticClass: "pickTime",
                                        staticStyle: { width: "100%" },
                                        attrs: {
                                          "prefix-icon": "0",
                                          format: "yyyy-MM-dd HH:mm",
                                          "value-format": "yyyy-MM-dd HH:mm:ss",
                                          type: "datetime",
                                          clearable: "",
                                        },
                                        model: {
                                          value: _vm.bkVgmWeb.vgmDate,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.bkVgmWeb,
                                              "vgmDate",
                                              $$v
                                            )
                                          },
                                          expression: "bkVgmWeb.vgmDate",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t("vgmApplyInfo.location"),
                                        prop: "location",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: { clearable: "" },
                                        model: {
                                          value: _vm.bkVgmWeb.location,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.bkVgmWeb,
                                              "location",
                                              $$v
                                            )
                                          },
                                          expression: "bkVgmWeb.location",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-collapse-item",
                        { attrs: { title: "Shipper VGM", name: "2" } },
                        [
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "vgmApplyInfo.shipperName"
                                        ),
                                        prop: "shipperName",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: { clearable: "" },
                                        model: {
                                          value: _vm.bkVgmWeb.shipperName,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.bkVgmWeb,
                                              "shipperName",
                                              $$v
                                            )
                                          },
                                          expression: "bkVgmWeb.shipperName",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "vgmApplyInfo.shipperVgmName"
                                        ),
                                        prop: "shipperVgmName",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: { clearable: "" },
                                        model: {
                                          value: _vm.bkVgmWeb.shipperVgmName,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.bkVgmWeb,
                                              "shipperVgmName",
                                              $$v
                                            )
                                          },
                                          expression: "bkVgmWeb.shipperVgmName",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "vgmApplyInfo.shipperAddress"
                                        ),
                                        prop: "shipperAddress",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: { clearable: "" },
                                        model: {
                                          value: _vm.bkVgmWeb.shipperAddress,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.bkVgmWeb,
                                              "shipperAddress",
                                              $$v
                                            )
                                          },
                                          expression: "bkVgmWeb.shipperAddress",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "vgmApplyInfo.shipperVgmEmail"
                                        ),
                                        prop: "shipperVgmEmail",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: { clearable: "" },
                                        model: {
                                          value: _vm.bkVgmWeb.shipperVgmEmail,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.bkVgmWeb,
                                              "shipperVgmEmail",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "bkVgmWeb.shipperVgmEmail",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "vgmApplyInfo.shipperVgmTelephone"
                                        ),
                                        prop: "shipperVgmTelephone",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: { clearable: "" },
                                        model: {
                                          value:
                                            _vm.bkVgmWeb.shipperVgmTelephone,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.bkVgmWeb,
                                              "shipperVgmTelephone",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "bkVgmWeb.shipperVgmTelephone",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "vgmApplyInfo.vgmCertificateId"
                                        ),
                                        prop: "vgmCertificateId",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: { clearable: "" },
                                        model: {
                                          value: _vm.bkVgmWeb.vgmCertificateId,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.bkVgmWeb,
                                              "vgmCertificateId",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "bkVgmWeb.vgmCertificateId",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "vgmApplyInfo.shipperVgmPerson"
                                        ),
                                        prop: "shipperVgmPerson",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: { clearable: "" },
                                        model: {
                                          value: _vm.bkVgmWeb.shipperVgmPerson,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.bkVgmWeb,
                                              "shipperVgmPerson",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "bkVgmWeb.shipperVgmPerson",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "vgmApplyInfo.shipperVgmPersonSig"
                                        ),
                                        prop: "shipperVgmPersonSig",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: { clearable: "" },
                                        model: {
                                          value:
                                            _vm.bkVgmWeb.shipperVgmPersonSig,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.bkVgmWeb,
                                              "shipperVgmPersonSig",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "bkVgmWeb.shipperVgmPersonSig",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "vgmApplyInfo.vgmDeclarationParty"
                                        ),
                                        prop: "vgmDeclarationParty",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: { clearable: "" },
                                        model: {
                                          value:
                                            _vm.bkVgmWeb.vgmDeclarationParty,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.bkVgmWeb,
                                              "vgmDeclarationParty",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "bkVgmWeb.vgmDeclarationParty",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "vgmApplyInfo.vgmEquipmentId"
                                        ),
                                        prop: "vgmEquipmentId",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: { clearable: "" },
                                        model: {
                                          value: _vm.bkVgmWeb.vgmEquipmentId,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.bkVgmWeb,
                                              "vgmEquipmentId",
                                              $$v
                                            )
                                          },
                                          expression: "bkVgmWeb.vgmEquipmentId",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "vgmApplyInfo.shipperOther"
                                        ),
                                        prop: "shipperOther",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: { clearable: "" },
                                        model: {
                                          value: _vm.bkVgmWeb.shipperOther,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.bkVgmWeb,
                                              "shipperOther",
                                              $$v
                                            )
                                          },
                                          expression: "bkVgmWeb.shipperOther",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-collapse-item",
                        {
                          attrs: { title: "VGM Weighting Company", name: "3" },
                        },
                        [
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t("vgmApplyInfo.name"),
                                        prop: "name",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: { clearable: "" },
                                        model: {
                                          value: _vm.bkVgmWeb.name,
                                          callback: function ($$v) {
                                            _vm.$set(_vm.bkVgmWeb, "name", $$v)
                                          },
                                          expression: "bkVgmWeb.name",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "vgmApplyInfo.contactName"
                                        ),
                                        prop: "contactName",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: { clearable: "" },
                                        model: {
                                          value: _vm.bkVgmWeb.contactName,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.bkVgmWeb,
                                              "contactName",
                                              $$v
                                            )
                                          },
                                          expression: "bkVgmWeb.contactName",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "vgmApplyInfo.contactTelephone"
                                        ),
                                        prop: "contactTelephone",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: { clearable: "" },
                                        model: {
                                          value: _vm.bkVgmWeb.contactTelephone,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.bkVgmWeb,
                                              "contactTelephone",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "bkVgmWeb.contactTelephone",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "vgmApplyInfo.contactEmail"
                                        ),
                                        prop: "contactEmail",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: { clearable: "" },
                                        model: {
                                          value: _vm.bkVgmWeb.contactEmail,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.bkVgmWeb,
                                              "contactEmail",
                                              $$v
                                            )
                                          },
                                          expression: "bkVgmWeb.contactEmail",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "vgmApplyInfo.contactPerson"
                                        ),
                                        prop: "contactPerson",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: { clearable: "" },
                                        model: {
                                          value: _vm.bkVgmWeb.contactPerson,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.bkVgmWeb,
                                              "contactPerson",
                                              $$v
                                            )
                                          },
                                          expression: "bkVgmWeb.contactPerson",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                { attrs: { span: 6 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "vgmApplyInfo.contactPersonSig"
                                        ),
                                        prop: "contactPersonSig",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: { clearable: "" },
                                        model: {
                                          value: _vm.bkVgmWeb.contactPersonSig,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.bkVgmWeb,
                                              "contactPersonSig",
                                              $$v
                                            )
                                          },
                                          expression:
                                            "bkVgmWeb.contactPersonSig",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t(
                                          "vgmApplyInfo.contactOther"
                                        ),
                                        prop: "contactOther",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: { clearable: "" },
                                        model: {
                                          value: _vm.bkVgmWeb.contactOther,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.bkVgmWeb,
                                              "contactOther",
                                              $$v
                                            )
                                          },
                                          expression: "bkVgmWeb.contactOther",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-row",
                            [
                              _c(
                                "el-col",
                                { attrs: { span: 12 } },
                                [
                                  _c(
                                    "el-form-item",
                                    {
                                      attrs: {
                                        label: _vm.$t("vgmApplyInfo.address"),
                                        prop: "address",
                                      },
                                    },
                                    [
                                      _c("el-input", {
                                        attrs: {
                                          type: "textarea",
                                          rows: 2,
                                          clearable: "",
                                        },
                                        model: {
                                          value: _vm.bkVgmWeb.address,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.bkVgmWeb,
                                              "address",
                                              $$v
                                            )
                                          },
                                          expression: "bkVgmWeb.address",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div"),
                  _vm._v(" "),
                  _c(
                    "el-row",
                    [
                      _c(
                        "el-col",
                        { attrs: { span: 12 } },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: _vm.$t("vgmApplyInfo.rejectReason"),
                                prop: "rejectReason",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  rows: 2,
                                  clearable: "",
                                  disabled: "",
                                },
                                model: {
                                  value: _vm.bkVgmWeb.rejectReason,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.bkVgmWeb, "rejectReason", $$v)
                                  },
                                  expression: "bkVgmWeb.rejectReason",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: { "text-align": "center", padding: "5px 5px 25px" },
            },
            [
              _c(
                "el-button",
                {
                  staticClass: "btn-primary",
                  staticStyle: { width: "110px" },
                  attrs: { type: "success", icon: "el-icon-document-copy" },
                  on: {
                    click: function ($event) {
                      return _vm.saveAndCopy("bkVgmWeb")
                    },
                  },
                },
                [
                  _vm._v(
                    "\n        " +
                      _vm._s(_vm.$t("button.saveCopy")) +
                      "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticClass: "btn-primary",
                  staticStyle: { width: "110px" },
                  attrs: { type: "success", icon: "el-icon-folder-add" },
                  on: {
                    click: function ($event) {
                      return _vm.saveAndNew("bkVgmWeb")
                    },
                  },
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.$t("button.saveNew")) + "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticClass: "btn-primary",
                  staticStyle: { width: "110px" },
                  attrs: { type: "success", icon: "el-icon-folder-checked" },
                  on: {
                    click: function ($event) {
                      return _vm.addBkVgmWeb("bkVgmWeb")
                    },
                  },
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.$t("button.save")) + "\n      "
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  staticClass: "btn-plain-primary",
                  staticStyle: { width: "110px" },
                  attrs: { type: "primary", icon: "el-icon-back" },
                  on: { click: _vm.back },
                },
                [
                  _vm._v(
                    "\n        " + _vm._s(_vm.$t("button.back")) + "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
        ]
      ),
      _vm._v(" "),
      _c("importResultDialog", {
        ref: "importResultDialog",
        attrs: {
          "destroy-on-close": true,
          width: "55%",
          importRes: _vm.importRes,
          notice: _vm.notice,
          visible: _vm.importResultDialogVisible,
        },
        on: {
          "update:visible": function ($event) {
            _vm.importResultDialogVisible = $event
          },
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }